// 鉴权相关
import router from "@/router";
import ls from "local-storage";
import get from "lodash.get";

export default {
  namespaced: true,
  state: {
    authInfo: {} // 通用, 登录,
  },
  mutations: {
    updateAuthInfo(state, authInfo) {
      state.authInfo = authInfo;
    },
    clearAuthInfo(state) {
      state.authInfo = {};
    }
  },
  actions: {
    async extractLocalAuthInfoThenAuth({ dispatch }) {
      if (await dispatch("haveLocalAuthInfo")) {
        await dispatch("newLocalAuthInfo");
      } else {
        dispatch("toLogin");
      }
    },
    // 抽取登录态信息并且初始化登录态
    async extractAuthInfoThenAuth({ dispatch }) {
      if (await dispatch("haveQueryAuthInfo")) {
        await dispatch("newQueryAuthInfo");
      } else if (await dispatch("haveLocalAuthInfo")) {
        await dispatch("newLocalAuthInfo");
      }
    },

    // 抽取本地authInfo进行鉴权
    async newLocalAuthInfo({ dispatch }) {
      const authInfo = await dispatch("getLocalAuthInfo");
      await dispatch("newAuthInfo", { authInfo });
    },

    async newAuthInfo({ dispatch }, { authInfo }) {
      await dispatch("saveLocalAuthInfo", { authInfo });
      await dispatch("initAuth", { authInfo });
    },

    async saveLocalAuthInfo({ dispatch }, { authInfo }) {
      if (authInfo) {
        dispatch("setLocalAuthInfo", { authInfo });
      }
    },

    // 设置登录态
    async initAuth({ dispatch, commit }, { authInfo }) {
      commit("updateAuthInfo", authInfo);
    },

    async haveLocalAuthInfo({ dispatch }) {
      const authInfo = await dispatch("getLocalAuthInfo");
      return dispatch("authInfoExist", authInfo);
    },

    authInfoExist({}, authInfo) {
      return !!get(authInfo, "token");
    },

    authInvalid({ commit, dispatch }) {
      commit("clearAuthInfo");
      dispatch("clearLocalAuthInfo");
      dispatch("toLogin");
    },
    // 去登录
    toLogin() {
      // router.replace({ path: '/login', query: { redirect: router.app.$route.fullPath } })
      router.replace({ path: "/login" });
    },
    // 清除查询参数
    setLocalAuthInfo(context, { authInfo }) {
      ls.set("authInfo", authInfo);
    },
    getLocalAuthInfo() {
      return ls.get("authInfo");
    },
    clearLocalAuthInfo() {
      ls.remove("authInfo");
    }
  },
  getters: {
    isLogin(state) {
      return !!get(state, "authInfo.token");
    },
    getToken(state) {
      return get(state, "authInfo.token");
    },
    accountName(state) {
      return get(state, "authInfo.accountName");
    },
    phone(state) {
      return get(state, "authInfo.phone");
    },
    role(state) {
      return get(state, "authInfo.role");
    },
    avatar(state) {
      return get(state, "authInfo.avatar");
    },
    teacherId(state) {
      return get(state, "authInfo.memberId");
    },
    distributorId(state) {
      return get(state, "authInfo.distributorId");
    },
    distributorName(state){
      return get(state, "authInfo.distributorName");
    },
    permissions(state) {
      return get(state, "authInfo.permission", "")
        .split(",")
        .filter(el => el !== "");
    },
    haveAnyPermission(state, getters) {
      return getters.permissions.length > 0;
    },
    isTeacher(state) {
      return get(state, "authInfo.role") === 2;
    },
    isDistributor(state) {
      return get(state, "authInfo.role") === 1;
    },
    hasClassPermission(state) {
      return get(state, "authInfo.permission", "").includes("3");
    },
    hasOCPermission(state) {
      return get(state, "authInfo.permission", "").includes("5");
    },
    hasOPPermission(state) {
      return get(state, "authInfo.permission", "").includes("2");
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js